import { redFromArgb, greenFromArgb, blueFromArgb } from '@material/material-color-utilities';

/**
 * Converts a Material Color Utilities ARGB number to an "R, G, B" string.
 *
 * @param color - The ARGB color number.
 * @returns A string representation of the RGB values.
 */
export const colorToRgbString = (color: number): string => `${redFromArgb(color)} ${greenFromArgb(color)} ${blueFromArgb(color)}`;
